import { Alert, Snackbar } from "@mui/material";
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import { createStyles, makeStyles, Theme, StylesProvider } from "@material-ui/core/styles";

interface Props {
  open: any
  onClose: any
  msg: string
}

export const MsgErrListSnackbar = ({ open, onClose, msg }: Props) => {

  const useSnackbarClassStyles = makeStyles((theme: Theme) =>
    createStyles({
      error: {
        color: "#fff",
        backgroundColor: "#E10009"
      }
    })
  );
  const snackbarClass = useSnackbarClassStyles();

  return (
    <StylesProvider>
      <Snackbar
        className={snackbarClass.error}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={open}
        autoHideDuration={null}
        onClose={onClose}
      >
        <Alert
          className={snackbarClass.error}
          severity="error"
          sx={{ width: '100%', backgroundColor: '#E10009', color: '#fff', overflowY: "auto", maxHeight: "88px" }}
          onClose={onClose}
          iconMapping={{
            error: <ErrorOutline fontSize="inherit" className={snackbarClass.error} />,
          }}
        >
          <label className="msg-list">{msg}</label>
        </Alert>
      </Snackbar>
    </StylesProvider>
  );
}

export default MsgErrListSnackbar;
